module.exports = __webpack_public_path__ + "img/instagram.a31c54ef.svg";